import type { LegalCopy } from '../types'

export const en: LegalCopy = {
  title: 'Kanooni Madad — Legal help',
  subtitle: 'Common legal problems, explained simply. Listen in your language, and see the official source for every answer.',
  helplinesTitle: 'Helplines (free calls)',
  helplines: {
    emergency: 'Emergency: police, fire, ambulance',
    legal_aid: 'Free legal aid (NALSA)',
    cyber: 'Online / UPI fraud',
    women: 'Women helpline',
    consumer: 'Consumer helpline'
  },
  faqTitle: 'Common questions',
  searchPlaceholder: 'Search: FIR, fraud, RTI, lawyer…',
  noMatch: 'No question matched. Ask it below instead.',
  sources: 'Official source',
  listen: 'Listen',
  askTitle: 'Ask your own legal question',
  askHint: 'Samjho answers only from official government websites, with the source link.',
  starters: ['Can I get a free lawyer?', 'Someone cheated me online. What should I do?', 'The police are not writing my complaint. What can I do?'],
  disclaimer:
    'This is general information from official sources, not legal advice for your case. For your case, talk to a lawyer — you may get one free from the Legal Services Authority (15100).',
  topics: {
    get_free_aid: {
      q: 'How do I get free legal help?',
      a: 'Call the free NALSA helpline 15100. Or go to the Legal Services Authority office in your District Court, or the Legal Services Committee in your taluka court. You can also apply online, by post or by e-mail. The form is free, and the lawyer’s fees and court costs are paid for you.'
    },
    who_free_aid: {
      q: 'Who can get a free lawyer?',
      a: 'The law (Section 12 of the Legal Services Authorities Act) gives free legal help to: women and children, SC/ST members, persons with disability, industrial workers, victims of trafficking or forced labour, victims of disasters, caste atrocities or ethnic violence, people in custody, and people whose yearly income is below the limit set by their state. The income limit is different in each state.'
    },
    fir: {
      q: 'The police are not registering my FIR. What can I do?',
      a: 'For a serious (cognizable) crime, you can report it at any police station, even if it happened somewhere else — this is called a Zero FIR. The police must give you a free copy of the FIR. If they refuse, send your complaint in writing by post to the Superintendent of Police (SP). If the SP also does nothing, you can apply to the Magistrate, with an affidavit.'
    },
    cyber_fraud: {
      q: 'I lost money in an online or UPI fraud. What should I do?',
      a: 'Call 1930, the free National Cyber Crime Helpline, straight away — it works day and night. Reporting quickly helps stop the money from being moved away. Also report it on cybercrime.gov.in under “Financial Fraud”.'
    },
    women: {
      q: 'A woman is facing violence or harassment. Where can she get help?',
      a: 'In an emergency, dial 112 for police, fire or ambulance. Call 181, the free Women Helpline, any time, day or night. You can stay anonymous, and it connects you to the police, a One Stop Centre, a hospital or legal help. The National Commission for Women also has a helpline, 14490, and takes complaints online.'
    },
    consumer: {
      q: 'A shop or company cheated me. Where do I complain?',
      a: 'Call the National Consumer Helpline on 1915 (free, 8 AM to 8 PM), send a WhatsApp message to 8800001915, or complain on consumerhelpline.gov.in. To file a case in the Consumer Commission, you can do it online on e-Daakhil.'
    },
    summons: {
      q: 'I got a court summons. What should I do?',
      a: 'A summons tells you to come to court on a given date. If you are eligible, you can get a free lawyer at any stage of a case: call 15100 or visit the legal services office in your District Court. You can check your case and its next date on the eCourts website or app.'
    },
    case_status: {
      q: 'How do I check my court case status?',
      a: 'Go to services.ecourts.gov.in, or use the eCourts Services app, and search with your 16-digit CNR number or other case details. You can also send an SMS: ECOURTS, a space, and your CNR number, to 9766899899.'
    },
    lok_adalat: {
      q: 'What is a Lok Adalat?',
      a: 'A Lok Adalat settles cases by agreement between both sides. There is no court fee, and if a case already in court is settled there, the court fee you paid is refunded. Its decision is final and binding like a court decree, and there is no appeal against it.'
    },
    rti: {
      q: 'How do I file an RTI?',
      a: 'For central government offices, apply online at rtionline.gov.in. The fee is ₹10; there is no fee if you are below the poverty line (attach your BPL certificate). The officer must reply within 30 days, or within 48 hours if it is about someone’s life or liberty. If there is no reply in 30 days, you can file a free first appeal within the next 30 days.'
    },
    grievance: {
      q: 'A government office is not doing my work. Where do I complain?',
      a: 'Lodge a complaint on CPGRAMS at pgportal.gov.in, open day and night (also on its app and on UMANG). The target is to solve it within 21 days. It does not take RTI matters, court cases, religious matters or government employees’ service matters.'
    }
  }
}
